import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';
@Injectable({
  providedIn: 'root',
})
export class ClonesurveyService {
  constructor(private store: AngularFirestore) {}

  public async cloneSurvey(survey: any) {
    const oldDocRef = this.store.collection('surveys').doc(survey.uuid);
    const questions = await oldDocRef.collection('questions').valueChanges();
    const id = this.store.createId();
    survey.uuid = id;
    survey.name = 'Clone ' + survey.name;
    survey.isActive = false;
    survey.startdate = firebase.default.firestore.Timestamp.now();
    const newDocRef = this.store.collection('surveys').doc(id);
    newDocRef.set(survey);
    questions.subscribe((items) => {
      items.forEach((question: any) => {
        newDocRef.collection('questions').doc(question.uuid).set(question);
      });
    });
    return newDocRef;
  }
}
